/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Profile_HeadingInputs */

const en_onboarding_v1_profile_heading = /** @type {(inputs: Onboarding_V1_Profile_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which of these describe you?`)
};

const de_onboarding_v1_profile_heading = /** @type {(inputs: Onboarding_V1_Profile_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche dieser Aussagen beschreiben Sie?`)
};

const pt_br2_onboarding_v1_profile_heading = /** @type {(inputs: Onboarding_V1_Profile_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quais destas opções descrevem você?`)
};

const tr_onboarding_v1_profile_heading = /** @type {(inputs: Onboarding_V1_Profile_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bunlardan hangileri sizi tanımlıyor?`)
};

const zh_cn2_onboarding_v1_profile_heading = /** @type {(inputs: Onboarding_V1_Profile_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以下哪些描述符合您？`)
};

const zh_hk2_onboarding_v1_profile_heading = /** @type {(inputs: Onboarding_V1_Profile_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以下哪些描述符合您？`)
};

const ko_kr2_onboarding_v1_profile_heading = /** @type {(inputs: Onboarding_V1_Profile_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음 중 회원님을 설명하는 것은 무엇인가요?`)
};

const ru_ru2_onboarding_v1_profile_heading = /** @type {(inputs: Onboarding_V1_Profile_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Какие из этих утверждений описывают вас?`)
};

const es_419_onboarding_v1_profile_heading = /** @type {(inputs: Onboarding_V1_Profile_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuáles de estas opciones te describen?`)
};

/**
* | output |
* | --- |
* | "Which of these describe you?" |
*
* @param {Onboarding_V1_Profile_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_profile_heading = /** @type {((inputs?: Onboarding_V1_Profile_HeadingInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Profile_HeadingInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_profile_heading(inputs)
	if (locale === "de") return de_onboarding_v1_profile_heading(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_profile_heading(inputs)
	if (locale === "tr") return tr_onboarding_v1_profile_heading(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_profile_heading(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_profile_heading(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_profile_heading(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_profile_heading(inputs)
	return es_419_onboarding_v1_profile_heading(inputs)
});